export default {
	setTime(val, type = "", before = "-", after = ":") {
		if(val==undefined){
			return
		}
		if (val.indexOf(":") != -1) {
			return val.substr(0, 10) + " " + val.substr(11, 8)
		}
		let str;
		let d = new Date(val);
		let year = d.getFullYear();
		let month = (d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1);
		let date = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
		let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
		let minutes = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
		let seconds = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
		if (type == "year") {
			str = `${year}${before}${month}${before}${date}`
		}
		str = `${year}${before}${month}${before}${date} ${hours}${after}${minutes}${after}${seconds}`
		return str;
	}
}
